import { render } from "./RegisterSite.vue?vue&type=template&id=8bada6fa&ts=true"
import script from "./RegisterSite.vue?vue&type=script&lang=ts"
export * from "./RegisterSite.vue?vue&type=script&lang=ts"

import "./RegisterSite.vue?vue&type=style&index=0&id=8bada6fa&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__